export default __webpack_public_path__ + "static/media/Acolyte's Straps of the Sacred Mountain.e2750501.jpg";